// 3rd party libs
import React from 'react';
import cs from 'classnames';

// local imports
import DownloadIcon from '../../../assets/icons/download.svg';
import styles from './DownloadButton.module.scss';

type TDownloadButton = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};
const DownloadButton: React.FC<TDownloadButton> = ({ onClick, className, disabled }) => {
  if (disabled) {
    return <img className={cs(styles.btn, className, styles.disabled)} src={DownloadIcon} alt="disabled download button" />;
  }

  return <img onClick={onClick} className={cs(styles.btn, className)} src={DownloadIcon} alt="download button" />;
};

export default DownloadButton;
